export default "__VITE_ASSET__BWIZ_4EI__"